import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import LStore from "store";
import VueI18n from "vue-i18n";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import en from "./lang/en";
import zh from "./lang/zh";
import Element from "element-ui";
import ResetCss from "reset-css";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";

Vue.use(ResetCss);
Vue.use(VueI18n);

const language = LStore.get("language");

if (language !== undefined) {
  store.commit("LANGUAGE", language);
} else {
  store.commit("LANGUAGE", "zh");
}

const messages = {
  en: {
    ...en,
    ...enLocale
  },
  zh: {
    ...zh,
    ...zhLocale
  }
};
const i18n = new VueI18n({
  locale: store.state.language,
  messages
});

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});

Vue.config.productionTip = false;

const userInfo = LStore.get("anselmUserInfo");
const productData = LStore.get("productData");
if (userInfo !== undefined) {
  store.commit("USER_INFO", userInfo);
  store.commit("IS_LOGIN", true);
} else {
  store.commit("USER_INFO", null);
  store.commit("IS_LOGIN", false);
}
if (productData !== undefined) {
  store.commit("PRODUCT_DATA", productData);
} else {
  store.commit("PRODUCT_DATA", []);
}

// router.beforeEach(async (to, from, next) => {
//   const router = ["product", "manual", "video"];
//   next();
//   if (to.name !== null) {
//     if (router.includes(to.name)) {
//       //location.reload();
//     }
//   }
// });

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
